export const VITE_BASE_URL: string = import.meta.env.VITE_BASE_URL || ''
export const NODE_ENV: string = import.meta.env.VITE_NODE_ENV || ''
export const VAPID_PUBLIC_KEY: string = import.meta.env.VITE_VAPID_PUBLIC_KEY || ''
export const USER_TOKEN_COOKIE_NAME: string = '$W$E$B$F$L$A$K$O$N$.$U$Z$U$S$E$R$T$O$K$E$N$'